import { Record as record } from 'immutable';

import { resolve } from '../../helpers/LinkMapper';

const defaults = {
    paymentMethodToken: null,
    cardHolderName: null,
    cardType: null,
    isExpired: null,
    expirationMonth: null,
    expirationYear: null,
    last4: null,
};

class BraintreeStoredCard extends record(defaults) {

    static fromJSON (json = {}) {
        return new BraintreeStoredCard({
            paymentMethodToken: resolve(json.paymentMethodToken).with(String),
            cardHolderName: resolve(json.cardHolderName).with(String),
            cardType: resolve(json.cardType).with(String),
            isExpired: resolve(json.isExpired).with(Boolean),
            expirationMonth: resolve(json.expirationMonth).with(Number),
            expirationYear: resolve(json.expirationYear).with(Number),
            last4: resolve(json.last4).with(String),
        });
    }

    getExpiryDate () {
        return `${this.expirationMonth}/${this.expirationYear}`;
    }

}


export default BraintreeStoredCard;
